import { atom } from 'recoil';
import { persistAtom } from '../utils/persistAtom';

export const activeOrderIdState = atom<string | undefined>({
	key: 'activeOrderId',
	default: undefined,
	effects_UNSTABLE: [persistAtom]
});

export const unreadActiveOrderNotificationsState = atom<number>({
	key: 'unreadActiveOrderNotifications',
	default: 0,
	effects_UNSTABLE: [persistAtom]
});
